/* eslint-disable prettier/prettier */
import { RestClient } from '../lib/RestClient'

class UserServices extends RestClient {
    // eslint-disable-next-line prettier/prettier
    // eslint-disable-next-line prettier/prettier
    // eslint-disable-next-line prettier/prettier
    constructor() {
        // eslint-disable-next-line prettier/prettier
        super('user')
    }

    async getPerfil(params = {}) {
        const response = await this.request.get('perfil', {
            params
        })
        return response.data
    }
}

export const Usuario = new UserServices()